<div class="work-packages-partitioned-query-space--container"
  [ngClass]="currentPartition">
  <op-breadcrumbs [items]="breadcrumbItems()"
    [lastItemSection]="currentMenuSectionHeader()"
   />
  <div class="toolbar-container -editable">
    <div class="toolbar">
      <h2 class="toolbar-title--container">
        <editable-toolbar-title [title]="selectedTitle"
          [inFlight]="toolbarDisabled"
          [showSaveCondition]="showToolbarSaveButton"
          (onSave)="changeChangesFromTitle($event)"
          (onEmptySubmit)="updateTitleName('')"
          [editable]="titleEditingEnabled" />
      </h2>
      @if (showToolbar) {
        <ul class="toolbar-items hide-when-print"
          >
          @for (definition of toolbarButtonComponents; track definition) {
            @if (!definition.show || definition.show()) {
              <li class="toolbar-item"
                [ngClass]="definition.containerClasses">
                <ndc-dynamic [ndcDynamicComponent]="definition.component"
                  [ndcDynamicInputs]="definition.inputs"
                  [ndcDynamicInjector]="injector"
                  [ndcDynamicOutputs]="definition.outputs" />
              </li>
            }
          }
        </ul>
      }
    </div>
  </div>

  <div class="work-packages-partitioned-query-space--filter-area">
    @if (filterContainerDefinition) {
      <ndc-dynamic [ndcDynamicComponent]="filterContainerDefinition.component"
        [ndcDynamicInputs]="filterContainerDefinition.inputs"
        [ndcDynamicOutputs]="filterContainerDefinition.outputs"
        [ndcDynamicInjector]="injector" />
    }
  </div>

  <div class="work-packages-partitioned-page--content-container">
    <!-- Board list content -->
    <board-list-container [boardId]="boardId" />
  </div>
</div>
